<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div class="card package h-100">
        <div class="card-body text-center">
          <h5 class="card-title">{{ trans('my_account') }}</h5>
          <p class="card-text text-left">
            {{ trans('my_account_about') }}
          </p>
          <a class="btn btn-branded" :href="`${iframeUrlPrefix}/org/${organization.id }/client`" target="_blank">
            {{ trans('my_account') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      block: Object,
    },
    computed: {
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
    },
    data() {
      return {
        trans: trans,
        iframeUrlPrefix: _.iframeUrlPrefix,
      }
    },
  }
</script>